// extracted by mini-css-extract-plugin
export default {"modelContent":"ServiceModal_modelContent__4aQLe"};